<script>
import TemplateMixin from './mixins/TemplateMixin';
import StripeCardModal from './components/StripeCardModal';
import StripeCardInline from './components/StripeCardInline';
import BaseGateway from './mixins/BaseGateway';
import {mapState} from 'vuex';
import StripeHandler from './libs/StripeHandler';

export default {
        name: "StripeGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],
        data(){
            return {
                stripeApi : null,
                stripeElements: null,
                selectedPaymentMethod: 'card',
                availablePaymentMethods: ['card'],
                planId: this.product.planId || null
            }
        },
        computed:{
            ...mapState([
                'stripePublicKey',
                'currencyCode',
                'activeStripeSourcePaymentMethods'
            ]),
            gateway(){
                return 'stripe';
            },
            noCard(){
                if(this.isFree){
                    return true;
                }

                if(this.checkoutData.trial_no_card && this.productData.trial_days > 0){
                    return true;
                }

                if(this.isStripeSourcePayment) {
                    return true;
                }

                return false;
            },
            finalPrice(){
                let price = this.productData.price;
                if(this.productData.discountFlag){
                    price = this.productData.discountPrice;
                }
                if(this.activeCoupon){
                    price = this.activeCoupon.price
                }

                if(this.planId){
                    price = this.paymentPlanPrice;
                }
                return price;
            },
            totalAmountDescription() {
                if (this.planId && !this.isStripeSourcePayment) {
                    let price = this.productData.discountFlag
                        ? this.productData.discountPrice
                        : this.paymentPlanPrice;

                    return `
                        ${this.i18n.get('payments.current_payment')}:
                        ${this.formatPrice(this.selectedPaymentPlan.firstAmount)} -
                        ${this.i18n.get('payments.total_payments')}:
                        ${this.formatPrice(this.noNegativeNumber(price))}
                    `;
                }

                if (this.product.type === 'subscription') {
                    if (this.activeCoupon && this.activeCoupon.durationType !== 'forever') {
                        let numberOfMonthsLabel = this.activeCoupon.durationType === 'once'
                            ? this.i18n.get('common.month')
                            : `${this.activeCoupon.duration} ${this.i18n.get('common.months')}`;

                        let discountLabel = this.activeCoupon.price < 0
                            ? this.i18n.get('payments.full_discount')
                            : `
                                ${this.i18n.get('payments.discount_of')}
                                ${this.formatPrice(this.productData.price - this.activeCoupon.price)}
                            `

                        return `
                            ${this.i18n.get('payments.subscription_fee')}:
                            ${this.formatPrice(this.noNegativeNumber(this.productData.price))} / ${this.subscriptionIntervalText}
                            <div class="learnworlds-overline-text">
                                (${this.i18n.get('payments.your_coupon')} ${this.activeCoupon.name}
                                 ${this.i18n.get('payments.coupon_applies')} ${discountLabel}
                                 ${this.i18n.get('payments.coupon_for_the_first')} ${numberOfMonthsLabel})
                            </div>
                        `;
                    }

                    let price = this.activeCoupon
                        ? this.activeCoupon.price
                        : this.productData.price;

                    return `
                        ${this.i18n.get('payments.subscription_fee')}:
                        ${this.formatPrice(this.noNegativeNumber(price))} / ${this.subscriptionIntervalText}
                    `;
                }

                let price = this.productData.price;

                if(this.productData.discountFlag){
                    price = this.productData.discountPrice;
                }

                if(this.activeCoupon){
                    price = this.activeCoupon.price;
                }

                return `${this.i18n.get('payments.total')} ${this.formatPrice(this.noNegativeNumber(price))}`;
            },

            confirmOrderLabel() {
                if (this.productData.trial_days > 0) {
                    return this.i18n.get('payments.trial_begin');
                }

                return this.i18n.get('payments.buy');
            },
            isSubscription(){
                return this.productData.type == 'Model\\Subscription';
            },
            childActiveComponent(){
                return (!this.noCard && this.stripeApi )? 'StripeCardInline' : null;
            },
            stripeVars(){
                // var _this = this;
                // var amount = this.getCurrentAmount();

                // var email;
                // if (this.meData) {
                //     email = this.meData.email;
                // } else if (this.postData){
                //     email = this.postData.email;
                // }

                const stripeVars = {
                    product_id: this.productData.id,
                    type: this.productType,
                    coupon: (this.activeCoupon)? this.activeCoupon.name : null,
                    plan_id : this.planId

                };

                // if(this.enabledShipping){
                //     //Get all shipping fields
                //     for( key in this.shippingData){
                //         //Retrive the data for each key
                //         this.shippingData[key] = this.retrieveShippingData(key);
                //     }
                //     stripeVars['shipping'] = this.shippingData;
                // }

                // if(this.enabledVat){
                //     for( key in this.vatData){
                //         //Retrive the data for each key
                //         this.vatData[key] = this.retrieveVatData(key);
                //     }
                //     stripeVars['vat'] = this.vatData;

                // }
                if(this.billingInfo){
                    stripeVars['additional'] = this.billingInfo.replace(/\r\n|\r|\n/g,"<br />");
                }

                return stripeVars;
            },
            cardElements(){
                return this.$refs.childComponent.getCardElements();
            },
            stripeBillingInfo(){
                return this.$refs.childComponent.getBillingInfo();
            },
            hasPaymentPlans(){
                return this.productData.paymentPlans.length;
            },
            paymentPlans(){
                return this.productData.paymentPlans;
            },
            paymentPlansOptions(){
                const options =  this.paymentPlans.map(plan => { return {name: plan.name, value: plan.id}});
                options.unshift({name: 'One payment', value: null });
                return options;
            },
            hasCoupons(){
                return !this.planId;
            },
            selectedPaymentPlan(){
                return this.paymentPlans.find(plan => plan.id == this.planId);
            },
            paymentPlanPrice(){
                return (this.selectedPaymentPlan.amount * (this.selectedPaymentPlan.paymentsCount - 1)) + this.selectedPaymentPlan.firstAmount;
            }

        },
        mounted(){
            this.initStripeElements();
        },
        methods:{
            initStripeElements(){
                if(typeof window.Stripe !== 'undefined'){
                    this.stripeApi = window.Stripe(this.stripePublicKey);
                    this.stripeElements = this.stripeApi.elements();
                }else{
                    this.setErrors(['Woops something went wrong']);
                }

            },
            initCheckout(){
                this.setLoading(true);

                if(this.noCard){
                    window.location.href = this.redirectUrl;
                    return;
                }


                if(this.stripeApi){
                    this.stripeHandler = new StripeHandler(this.stripeApi,this.cardElements['cardNumber'], this.stripeVars, this.stripeBillingInfo, {
                        setErrors: this.setErrors,
                        setLoading: this.setLoading
                    });

                    this.stripeHandler.initPaymentFlow();
                }

            },
            childComponentProps(){
                return {
                    stripeApi: this.stripeApi,
                    stripeElements: this.stripeElements
                };
            },
            validate(){
                return new Promise((resolve,reject)=>{
                    const validations = [];

                    validations.push(this.$validator.validateAll());

                    if (!this.noCard) {
                        validations.push(this.$refs.childComponent.validate());
                    }

                    Promise.all(validations).then(result => {
                        result.forEach(res => {
                            //check if validateAll returns false
                            if (res === false) {
                                reject();
                            }
                        });
                        resolve();
                    }).catch(error => {
                        reject();
                    });
                });
            },
            noNegativeNumber(val) {
                return val < 0
                    ? 0
                    : val;
            }
        },
        components:{
            StripeCardModal,
            StripeCardInline
        }

}
</script>
